import * as React from 'react';
import {connect} from 'react-redux';
import {IconButton} from './iconbutton';
import {Subheading, SubheadingItem, SubheadingItemLocations} from './subheading';
import LocationFilter from './locationfilter';
import {Card, CardHeader, CardBody, CardActions} from './cards';
import {ExportModal} from './modals';
import {SubscribeModal} from './modals';
import {LocationFilterLevel} from '../model/geo';
import {Paginator} from './paginator';
import * as Locale from '../model/locale';
import {V2Premises, subscribeToPremises, updateDashboardDisplay} from '../model/premises';
import {loadStoreExport} from '../model/reports';
import {CABINETS_ROUTE_LISTING, appRoutes} from '../model/routes/main';
import LoadingPane from './loadingpane';
import {Button, Glyphicon} from 'react-bootstrap';
import {updateUserSettings, setContactModalValidationErrors, UserData} from "../model/account";
import * as _ from 'underscore';
import {getCabinetDataForPremise} from "../model/cabinets";


@connect(
    state => ({
        ui: state.ui.premises,
        contactModalValidationErrors: state.ui.accounts.contactModal.validationErrors,
        textForKey: state.data.textForKey,
        premises: state.data.premises,
        loading: state.ui.premises.loading || state.ui.geo.loading,
        user: state.data.user
    })
)
export class PremisesListing extends React.Component<any, any> {
    render() {
        const {loading, textForKey} = this.props;

        if (loading) {
            return <LoadingPane title={textForKey(Locale.TEXT_NAVIGATION_STORES)} />;
        }

        return this.buildPageContent();
    }

    private buildPageContent() {
        const {textForKey} = this.props;
        let add_premises = null, {user} = this.props;
        let add = textForKey(Locale.TEXT_REGISTER_LINK_NEW_GATEWAY);

        if (user.features.can_register_premises) {
            add_premises = (<Button className="btn-add" bsStyle="link" href="#/premises/register">
                    <Glyphicon glyph="plus"/>
                    {add}
                </Button>
            );
        }
        return (
            <div className="container content">
                <Subheading title={textForKey(Locale.TEXT_NAVIGATION_STORES)}>
                    <SubheadingItem location={SubheadingItemLocations.LEFT}>
                        {add_premises}
                    </SubheadingItem>
                    {this.buildLocationFilter()}
                </Subheading>
                <div className="cards card-view">
                    {this.buildPremisesCards()}
                </div>
                {this.buildPagination()}
            </div>
        );
    }

    private buildPremisesCards() {
        let {premises, dispatch, ui, user, contactModalValidationErrors} = this.props;

        return premises.results.map(p => {
            let premisesProps = {
                ui: {
                    contactModalValidationErrors,
                    link: `${CABINETS_ROUTE_LISTING}?store_slug=${p.slug}`,
                    subscribeAction: (card: PremisesCard) => {
                        // if saved details
                        if (!p.subscribed && user.email.length === 0 &&
                                user.mobile.length === 0) {
                            // do modal popup
                            card.openContactDetails();

                        } else {
                            dispatch(subscribeToPremises(p.id, !p.subscribed));
                        }

                    },
                    updateUserAction: (card: PremisesCard, data: any) => {
                        dispatch(updateUserSettings(data))
                            .then(() => {
                                card.closeContactDetails();
                                dispatch(subscribeToPremises(p.id, !p.subscribed));
                            })
                            .catch(error => {
                                dispatch(setContactModalValidationErrors(null));
                                if (!_.isEmpty(error.data)) {
                                    dispatch(setContactModalValidationErrors(error.data));
                                }
                            });
                    },
                    dashboardAction: () => {
                        dispatch(updateDashboardDisplay(p.id, !p.dashboard_display));
                    },
                    exportAction: (startDate, endDate, reportType, sensors, interval) => {
                        return dispatch(loadStoreExport(p.id, p.name, startDate, endDate, user.language, reportType, sensors, interval));
                    },
                    getUnitsAction: () => {
                        return dispatch(getCabinetDataForPremise(p.id));
                    },
                    isSubscribing: (ui[p.id] && ui[p.id].isSubscribing) || false,
                    settingDashboardDisplay: (ui[p.id] && ui[p.id].settingDashboardDisplay) || false
                },
                data: { premises: p },
                user: user
            };
            return (
                <PremisesCard key={p.id} {...premisesProps} />
            );
        });
    }

    private buildLocationFilter() {
        const {location, history} = this.props;
        let locationfilterProps = {
            filterLevel: LocationFilterLevel.Premises,
            location,
            history
        };

        return <LocationFilter {...locationfilterProps} />;
    }

    private buildPagination() {
        let {premises, location} = this.props;
        /* TODO: paginator should have auto-conversion of query parameters */
        return <Paginator itemsPerPage={15}
                        totalItems={premises.count}
                        location={location}
                        page={parseInt(location.query.page || 1, 10)}
                        route={appRoutes.premises}
                        maxVisible={5} />;
    }
}

interface PremisesCardDataProps {
    premises: V2Premises;
}
interface PremisesCardUiProps {
    link: string;
    subscribeAction: (card: PremisesCard) => void;
    dashboardAction: () => void;
    exportAction: (startDate, endDate, reportType, sensors, intervalSecs) => void;
    getUnitsAction: () => void;
    isSubscribing: boolean;
    settingDashboardDisplay: boolean;
    updateUserAction: (card: PremisesCard, data: any) => void;
    contactModalValidationErrors: {[input: string]: string[]};
}
interface PremisesCardProps extends React.Props<PremisesCardProps> {
    user: UserData,
    data: PremisesCardDataProps;
    ui: PremisesCardUiProps;
    textForKey?: Function;
    premisesUnits?: any;
    sensorsLoading?: any;
}
interface PremisesCardState {
    showExport: boolean;
    showContact: boolean;
}

function subscribeButtonClass(ui, premises) {
    let className = 'btn-subscribe';
    if (ui.isSubscribing) {
        return className + ' icon-loading';
    }
    if (premises.subscribed) {
        return className + ' activated';
    }
    return className;
}

function dashboardAddButtonClass(ui, premises) {
    let className = 'btn-dashboard-add';
    if (ui.settingDashboardDisplay) {
        return className + ' icon-loading';
    }
    if (premises.dashboard_display) {
        return className + ' activated';
    }
    return className;
}

@connect(
    state => ({
        textForKey: state.data.textForKey,
        user: state.data.user,
        premisesUnits: state.data.premisesUnits,
        sensorsLoading: state.ui.premisesUnits.loading
    })
)
export class PremisesCard extends React.Component<PremisesCardProps, PremisesCardState> {
    state: {
        showExport: boolean;
        showContact: boolean;
    };

    constructor() {
        super();
        this.state = { showExport: false, showContact: false };
    }

    openExport() {
        this.setState({ showExport: true, showContact: false });

    }

    closeExport() {
        this.setState({ showExport: false, showContact: false});
    }

    openContactDetails() {

        this.setState({ showContact: true, showExport: false });
    }

    closeContactDetails() {
        this.setState({ showContact: false, showExport: false });
    }

    render() {
        let {premises} = this.props.data;
        let ui = this.props.ui;

        let onDashboard = premises.dashboard_display;
        let dashboardTextKey = onDashboard ?
            Locale.TEXT_TOOLTIP_REMOVE_FROM_DASHBOARD :
            Locale.TEXT_TOOLTIP_ADD_TO_DASHBOARD;
        let dashboardAttrs = {
            className: dashboardAddButtonClass(ui, premises),
            tooltip: this.props.textForKey(dashboardTextKey),
            onClick: ui.dashboardAction,
            activated: onDashboard,
            disabled: ui.settingDashboardDisplay
        };
        const dashboardAddBtn = <IconButton {...dashboardAttrs} />;

        let subscribeAttrs = {
            className: subscribeButtonClass(ui, premises),
            tooltip: this.props.textForKey(Locale.TEXT_TOOLTIP_SUBSCRIBE),
            onClick: (() => {
                ui.subscribeAction(this);
            }).bind(this),
            dataItem: premises,
            activated: premises.subscribed,
            disabled: ui.isSubscribing
        };

        let alarmBtnClass = 'btn-alarm';
        if (premises.uncleared_alarms > 0) {
            alarmBtnClass += ' activated';
        }

        let subscribeProps = {
            updateAction: ((data: any) => ui.updateUserAction(this, data)).bind(this),
            textForKey: this.props.textForKey,
            validationErrors:  ui.contactModalValidationErrors,
            state: {
                show: this.state.showContact,
                onHide: this.closeContactDetails.bind(this)
            }
        };

        let exportAttrs = {
            className: 'btn-export',
            tooltip: this.props.textForKey(Locale.TEXT_TOOLTIP_EXPORT),
            onClick: this.openExport.bind(this)
        };

        let exportProps = {
            user: this.props.user,
            exportAction: ui.exportAction,
            textForKey: this.props.textForKey,
            state: {
                show: this.state.showExport,
                onHide: this.closeExport.bind(this)
            },
            getUnitsAction: ui.getUnitsAction,
            premisesUnits: this.props.premisesUnits,
        };

        return (
            <Card link={ui.link} isParentCard={true}>
                <ExportModal ref="export" {...exportProps}/>
                <SubscribeModal ref="subscribe" {...subscribeProps}/>
                <CardHeader title={premises.name}
                    titleClassName="column-store"
                    subtitle={premises.street_address + " " + premises.locality}
                    subtitleClassName="column-address"
                    button={dashboardAddBtn} />
                <CardBody>
                    <dl>
                        <dt className="list-hide">
                            {this.props.textForKey(Locale.TEXT_CARD_NO_OF_UNITS)}
                        </dt>
                        <dd className="col-units">
                            {premises.num_of_units}
                        </dd>
                        <dt className="list-hide card-view-hide">
                            {this.props.textForKey(Locale.TEXT_CARD_NO_OF_ALARMS)}
                        </dt>
                        <dd className="col-alarms card-view-hide">
                            {premises.uncleared_alarms}
                        </dd>
                    </dl>
                </CardBody>
                <CardActions>
                    <IconButton href={`${appRoutes.alarms.path}?store_slug=${premises.slug}`}
                                className={alarmBtnClass}
                                tooltip={this.props.textForKey(Locale.TEXT_TOOLTIP_VIEW_ALARMS)}>
                        {premises.uncleared_alarms}
                    </IconButton>

                    <IconButton  {...subscribeAttrs} />

                    <IconButton  {...exportAttrs} />
                </CardActions>
            </Card>
        );
    }
}
